import styled from 'styled-components'

export const StyledOuterDiv = styled.div`
    display: grid;
    justify-content: center;
    align-items: center;
    height: 100%;
`

export const StyledInnerDiv = styled.div`
      max-width: 1040px;
      width: 100%;
      margin:auto;
      padding-top: 40px;
      padding-bottom: 40px;
        
      min-width: 70vw;
    
      border-radius: 8px;
      box-shadow: 0 20px 40px rgba(54, 55, 223, .15);
      @media (max-width: 768px) {
          padding-top: 30px;  
          padding-bottom: 30px;
      }
`
